import React, { useState } from 'react';
import './MobileFeatures.scss';

const MobileFeatures = () => {
    const [expandedCard, setExpandedCard] = useState("General");

    const toggleCard = (id: any) => {
        setExpandedCard(expandedCard === id ? null : id);
    };

    const featureGroups = {
        categories: [
            {
                name: "General",
                features: [
                    { id: 1, name: "Users", basic: "3", advanced: "10" },
                    { id: 2, name: "Locations/Branches", basic: "5", advanced: "Unlimited" },
                    {
                        id: 3, name: "Annual Fee",
                        basic: {
                            original: "Rs. 17999/-",
                            discounted: "Free** for AU Bank Customers®",
                            showStrike: true
                        },
                        advanced: {
                            original: "Rs. 37999/-",
                            discounted: "Rs. 9,999/- for AU Bank Customers®",
                            showStrike: true
                        }
                    }
                ]
            },
            {
                name: "Sales Features",
                features: [
                    { id: 4, name: "Quotes", basic: "Yes", advanced: "Yes" },
                    { id: 5, name: "Manage Customer", basic: "Yes", advanced: "Yes" },
                    { id: 6, name: "Invoices", basic: "Yes", advanced: "Yes" },
                    { id: 7, name: "Credit Notes", basic: "Yes", advanced: "Yes" },
                    { id: 8, name: "Invoice Customization", basic: "No", advanced: "Yes" },
                    { id: 9, name: "Payment Reminders", basic: "Yes", advanced: "Yes" },
                    { id: 10, name: "Online Payments", basic: "Yes", advanced: "Yes" },
                    { id: 11, name: "Record Offline Payments", basic: "Yes", advanced: "Yes" },
                    { id: 12, name: "Sales Orders", basic: "Yes", advanced: "Yes" },
                    { id: 13, name: "E Way Bills", basic: "Yes", advanced: "Yes" },
                    { id: 14, name: "e invoicing", basic: "Yes", advanced: "Yes" },
                    { id: 15, name: "Custom Branding on Invoices", basic: "No", advanced: "Yes" },
                    { id: 16, name: "Sales Approvals", basic: "Yes", advanced: "Yes" },
                    { id: 17, name: "Auto scan Bills/Invoices (AI Powered)", basic: "No", advanced: "Yes" },
                    { id: 18, name: "Multicurrency Invoicing", basic: "No", advanced: "Yes" },
                    { id: 19, name: "Automatic Exchange Rate", basic: "No", advanced: "Yes" },
                    { id: 20, name: "Multicurrency Transactions for each customer", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Purchase",
                features: [
                    { id: 21, name: "Bulk Uploads", basic: "Yes", advanced: "Yes" },
                    { id: 22, name: "Expense and bills", basic: "Yes", advanced: "Yes" },
                    { id: 23, name: "Manage Vendors", basic: "Yes", advanced: "Yes" },
                    { id: 24, name: "Vendor Credits", basic: "No", advanced: "Yes" },
                    { id: 25, name: "Record Payments Made", basic: "Yes", advanced: "Yes" },
                    { id: 26, name: "Purchase Orders", basic: "Yes", advanced: "Yes" },
                    { id: 27, name: "Auto scan Receipts/Invoices (AI Powered)", basic: "No", advanced: "Yes" },
                    { id: 28, name: "Multi-currency Transactions", basic: "No", advanced: "Yes" },
                    { id: 29, name: "Automatic Exchange Rate", basic: "No", advanced: "Yes" },
                    { id: 30, name: "Multicurrency Transaction for each vendor", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Banking",
                features: [
                    { id: 31, name: "Import Bank and Credit card statement", basic: "Yes", advanced: "Yes" },
                    { id: 32, name: "Import Bank and Credit card statement (AI Powered)", basic: "No", advanced: "Yes" },
                    { id: 33, name: "Bank Reconciliation (AI Powered)", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "General Accounting Setup",
                features: [
                    { id: 34, name: "Chart of Accounts", basic: "Yes", advanced: "Yes" },
                    { id: 35, name: "Sub-accounts", basic: "Yes", advanced: "Yes" },
                    { id: 36, name: "Manual Journals", basic: "Yes", advanced: "Yes" },
                    { id: 37, name: "Bulk update - account", basic: "Yes", advanced: "Yes" },
                    { id: 38, name: "Transaction Locking", basic: "Yes", advanced: "Yes" },
                    { id: 39, name: "Journal Templates", basic: "Yes", advanced: "Yes" },
                    { id: 40, name: "Base Currency adjustment", basic: "Yes", advanced: "Yes" },
                    { id: 41, name: "Recurring Journals", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Inventory",
                features: [
                    { id: 42, name: "Manage Items", basic: "Yes", advanced: "Yes" },
                    { id: 43, name: "Stock Tracking", basic: "Yes", advanced: "Yes" },
                    { id: 44, name: "Set Order Points (Minimum and Maximum Stock Management)", basic: "No", advanced: "Yes" },
                    { id: 45, name: "Batch Tracking", basic: "Yes", advanced: "Yes" }
                ]
            },
            {
                name: "Reporting",
                features: [
                    { id: 46, name: "Dashboard", basic: "Yes", advanced: "Yes" },
                    { id: 47, name: "Reports", basic: "Yes", advanced: "Yes" },
                    { id: 48, name: "Export and Print reports as PDF/spreadsheet", basic: "Yes", advanced: "Yes" },
                    { id: 49, name: "Custom Reports", basic: "No", advanced: "Yes" },
                    { id: 50, name: "Cash Flow Forecasting", basic: "No", advanced: "Yes" },
                    { id: 51, name: "Dashboard Customization (Additional Charges apply)", basic: "No", advanced: "Yes" },
                    { id: 52, name: "Financial insights Visualization (10+ modules)", basic: "Yes", advanced: "Yes" },
                    { id: 53, name: "Ageing Analysis (Debtor/Creditors)", basic: "Yes", advanced: "Yes" }
                ]
            },
            {
                name: "GST",
                features: [
                    { id: 54, name: "Invoice Management System", basic: "Yes", advanced: "Yes" },
                    { id: 55, name: "Activity Log", basic: "Yes", advanced: "Yes" },
                    { id: 56, name: "Transaction Locking", basic: "Yes", advanced: "Yes" },
                    { id: 57, name: "Customer user roles and access", basic: "Yes", advanced: "Yes" },
                    { id: 58, name: "Sales Approvals", basic: "Yes", advanced: "Yes" },
                    { id: 59, name: "Purchase approval", basic: "Yes", advanced: "Yes" },
                    { id: 60, name: "Record Locking", basic: "Yes", advanced: "Yes" },
                    { id: 61, name: "Auto Reconciliation of GSTR 2A/2B etc.", basic: "No", advanced: "Yes" },
                    { id: 62, name: "One Click Filing (GSTR1, GSTR 3B etc.)", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Projects/Branches",
                features: [
                    { id: 63, name: "Manage Projects/Branches", basic: "5", advanced: "Unlimited" },
                    { id: 64, name: "Projects Expense", basic: "Yes", advanced: "Yes" },
                    { id: 65, name: "Project Profitability", basic: "Yes", advanced: "Yes" }
                ]
            },
            {
                name: "Document Manager",
                features: [
                    { id: 66, name: "Create Folders", basic: "Yes", advanced: "Yes" },
                    { id: 67, name: "Upload Documents", basic: "Yes", advanced: "Yes" },
                    { id: 68, name: "Attach files to transactions and contacts", basic: "Yes", advanced: "Yes" },
                    { id: 69, name: "Multiple Sub-Folder Creation", basic: "Yes", advanced: "Yes" }
                ]
            },
            {
                name: "Customization",
                features: [
                    { id: 70, name: "Invoice Customization", basic: "No", advanced: "Yes" },
                    { id: 71, name: "Email Template Customization", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Additional Features",
                features: [
                    { id: 72, name: "Custom Modules", basic: "No", advanced: "Yes" },
                    { id: 73, name: "Email Alerts", basic: "No", advanced: "Yes" },
                    { id: 74, name: "Field Updates", basic: "No", advanced: "Yes" }
                ]
            },
            {
                name: "Support",
                features: [
                    { id: 75, name: "Voice", basic: "Yes", advanced: "Yes" },
                    { id: 76, name: "Email", basic: "Yes", advanced: "Yes" },
                    { id: 77, name: "In-Person (Additional Charges applicable)", basic: "Yes", advanced: "Yes" }
                ]
            },
            {
                name: "Unique Features",
                features: [
                    { id: 78, name: "Fixed Asset Register", basic: "No", advanced: "Yes" },
                    { id: 79, name: "Insights", basic: "Yes", advanced: "Yes" },
                    { id: 80, name: "SOP Maintenance Module", basic: "No", advanced: "Yes" },
                    { id: 81, name: "Compliance Calendar", basic: "Yes", advanced: "Yes" },
                    { id: 82, name: "Audit Trails", basic: "Yes", advanced: "Yes" },
                    { id: 83, name: "Segregation of Duties (Request to be raised on call centre)", basic: "No", advanced: "Yes" },
                    { id: 84, name: "One click GST Filing Feature", basic: "No", advanced: "Yes" },
                    { id: 85, name: "Comments by reviewer/approver", basic: "Yes", advanced: "Yes" }
                ]
            }
        ],
        managedServices: [
            "Virtual Accountant (Junior/Senior)",
            "Part Time Accountant (Experienced/Expert/Professional CA)",
            "Shared CFO Available as additional services to all the user on competitive charges",
            "MCA compliance and advisory Charges would be based on the complexity and time of task",
            "TDS compliances (Including Filing)",
            "GST compliance (Including Filing)",
            "ITR Filing"
        ],
        footerNote: "© The offer is applicable to the AU Bank customers only, please refer the offer conditions, terms and conditions apply."
    };

    const services = [
     
        "Virtual Accountant (Junior/Senior)",
            "Part Time Accountant (Experienced/Expert/Professional CA) available as additional services to all the user on competitive charges,Charges would be based on the complexity and time of task.",
            "Shared CFO",
            "MCA compliance available as additional services to all the user on competitive charges,Charges would be based on the complexity and time of task.",
            "TDS compliances (Including Filing)",
            "GST compliance (Including Filing) available as additional services to all the user on competitive charges,Charges would be based on the complexity and time of task.",
            "ITR Filing"
    ];

    return (
        <div className="mobile-features-container">
            {/* Feature Comparison Cards */}
            {featureGroups?.categories?.map((group: any) => (
                <div
                    key={group?.name}
                    className={`feature-card ${expandedCard === group?.name ? 'expanded' : ''}`}
                >
                    <div
                        className="card-header"
                        onClick={() => toggleCard(group?.name)}
                        aria-expanded={expandedCard === group?.name}
                    >
                        <h3>{group?.name}</h3>
                        <span className="toggle-icon">
                            {expandedCard === group?.name ? '−' : '+'}
                        </span>
                    </div>

                    <div className={`card-content ${expandedCard === group?.name ? 'show' : ''}`}>
                        <div className="feature-columns">
                            <div className="column feature-name">Feature</div>
                            <div className="column basic">Basic</div>
                            <div className="column premium">Premium</div>
                        </div>

                        {group.features.map((feature: any) => (
                            <div key={feature?.id} className="feature-row">
                                <div className="column feature-name">{feature?.name}</div>

                                {/* Basic Plan Value */}
                                <div className={`column basic ${feature.basic === 'Yes' ? 'available' : 'unavailable'}`}>
                                    {feature.id === 3 ? ( // Special case for Annual Fee
                                        <div className="price-group">
                                            <span className="original-price strikethrough">Rs. 17999/-</span>
                                            <span className="discounted-price">Free** for AU Bank Customers®</span>
                                        </div>
                                    ) : (
                                        <span>{feature.basic}</span>
                                    )}
                                </div>

                                {/* Premium Plan Value */}
                                <div className={`column premium ${feature.advanced === 'Yes' ? 'available' : 'unavailable'}`}>
                                    {feature.id === 3 ? ( // Special case for Annual Fee
                                        <div className="price-group">
                                            <span className="original-price strikethrough">Rs. 37999/-</span>
                                            <span className="discounted-price">Rs. 9,999/- for AU Bank Customers®</span>
                                        </div>
                                    ) : (
                                        <span>{feature.advanced}</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}

            {/* Services Card */}
            <div className={`feature-card ${expandedCard === 'services' ? 'expanded' : ''}`}>
                <div
                    className="card-header"
                    onClick={() => toggleCard('services')}
                    aria-expanded={expandedCard === 'services'}
                >
                    <h3>Managed Services</h3>
                    <span className="toggle-icon">
                        {expandedCard === 'services' ? '−' : '+'}
                    </span>
                </div>

                <div className={`card-content ${expandedCard === 'services' ? 'show' : ''}`}>
                    <ul className="services-list">
                        {services.map((service, index) => (
                            <li key={index}>{service}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MobileFeatures;